/**
 * Permission codes the FX exposure and period-revaluation screens declare
 * (`server/internal/fxreval/permissions.go`, FSD FIN-FR-023).
 *
 * `fx.period_reval.run` ⊗ `fx.period_reval.post` is a segregation-of-duties
 * pair, and holding both is not the control: the server refuses a post by the
 * person who prepared that particular run (`createdBy`). The run screen hides
 * Post from exactly that person and from nobody else.
 */

export const FX_EXPOSURE_PERMISSIONS = {
  /** The exposure report, the settings read, the run list, a run and its lines. */
  exposureRead: 'fx.exposure.read',
  /** Prepare a revaluation draft; discard a draft. */
  periodRevalRun: 'fx.period_reval.run',
  /** Post a prepared draft (not by its preparer). */
  periodRevalPost: 'fx.period_reval.post',
  /** Name the unrealised accounts and the monetary ledger accounts. */
  periodRevalConfigure: 'fx.period_reval.configure',

  /** Fiscal periods for the create-run picker. */
  fiscalRead: 'org.fiscal.read',
  /** Postable accounts for the settings pickers. */
  accountRead: 'org.account.read',
  /** Open the revaluation journal and its reversal. */
  journalRead: 'gl.journal.read',
} as const

export type FxExposurePermission = (typeof FX_EXPOSURE_PERMISSIONS)[keyof typeof FX_EXPOSURE_PERMISSIONS]
